import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsDailyViewEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.DAILY_VIEW_ENABLED, {
    defaultValue: false,
  });
}
